import { PERMISSION_LABELS, isKnownPermission } from '@/lib/access';

// A permission the panel does not know is shown by its id: it grants nothing here, but the person
// must still see that it is there.
export function permissionLabel(id: string): string {
  return isKnownPermission(id) ? PERMISSION_LABELS[id] : id;
}
